import React from "react";
import { Markdown } from 'react-showdown';
import DocumentationType from '../components/Type';
import { TypeParams, Source } from '../components/Others';

export default function TypeAlias({ docs }) {
    const Tags = () => {
        const tags = [];
        if (docs.comment.tags)
            for (const tag of docs.comment.tags)
                if (tag.tag === "see") tags.push(<a href={tag.text} style={{ marginTop: '-10px', display: 'block' }}>{tag.text}</a>);

        return tags;
    };

    return <>
        <h1>
            {docs.name}<TypeParams params={docs.typeParams}/> <Source sources={docs.sources}/>
        </h1>

        {docs.extends ? <h3 style={{ marginTop: '10px' }}>extends <DocumentationType type={docs.extends}/></h3> : null}
        <Markdown markdown={docs.comment.shortText || 'No documentation found.'}/>
        <Tags/>

        <hr style={{ marginTop: '15px'}}/>
        <h2 style={{ marginBottom: '10px' }}>Type: </h2>
        <DocumentationType type={docs.type}/>
    </>
}